import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

const HVS_MOBILE_MAX = 790;

function isHvsMobileLayout() {
  return typeof window.matchMedia === 'function' && window.matchMedia(`(max-width: ${HVS_MOBILE_MAX}px)`).matches;
}

function setPanelOverlap(panel) {
  if (!panel || !panel.isConnected) {
    return;
  }
  if (isHvsMobileLayout()) {
    panel.style.setProperty('--hvs-overlap', '0px');
    return;
  }
  const h = panel.offsetHeight;
  const overlap = Math.max(0, Math.round(h * 0.4));
  panel.style.setProperty('--hvs-overlap', `${overlap}px`);
}

function bindOverlap(panel) {
  if (!panel || panel.dataset.hvsOverlapBound === '1') {
    return;
  }
  panel.dataset.hvsOverlapBound = '1';

  const run = () => setPanelOverlap(panel);

  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(run);
    ro.observe(panel);
  }

  window.addEventListener('load', run, { once: true });
  window.addEventListener('resize', run);
  requestAnimationFrame(run);
}

function initHeadingVideoSplit() {
  document.querySelectorAll('.js-heading-video-split-panel').forEach((panel) => {
    bindOverlap(panel);
  });

  document.querySelectorAll('.js-heading-video-split-plyr').forEach((el) => {
    if (el.dataset.hvsPlyrInit === '1') {
      return;
    }
    el.dataset.hvsPlyrInit = '1';

    const wrap = el.closest('.heading-video-split__video');
    if (!wrap) {
      return;
    }

    const panel = el.closest('.js-heading-video-split-panel');
    const player = new Plyr(el, {
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen',
      ],
      clickToPlay: true,
      hideControls: false,
    });

    player.on('ready', () => {
      const media = player.media;
      if (media && media.tagName === 'VIDEO') {
        media.playsInline = true;
        media.setAttribute('playsinline', '');
        media.setAttribute('webkit-playsinline', '');
      }
      if (panel) {
        setPanelOverlap(panel);
      }
    });

    player.on('playing', () => {
      wrap.classList.add('is-playing');
    });
    player.on('pause', () => {
      wrap.classList.remove('is-playing');
    });
    player.on('ended', () => {
      wrap.classList.remove('is-playing');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeadingVideoSplit);
} else {
  initHeadingVideoSplit();
}
